import { render, staticRenderFns } from "./PersonalizedTour.vue?vue&type=template&id=57601b7e&"
import script from "./PersonalizedTour.vue?vue&type=script&lang=js&"
export * from "./PersonalizedTour.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PersonalizedTour.vue"
export default component.exports